<template>
  <v-card
    outlined
    class="hmi-setting"
    :style="recommendation ? 'max-width: 200px' : ''"
  >
    <div>
      <template v-if="recommendation">
        <div class="d-flex flex-wrap justify-space-between" style="gap: 4px">
          <v-chip
            v-for="(type, index) in valuesTypes"
            :key="type"
            style="flex: 1 1 48%; max-width: 90px"
            class="direction-ltr d-flex align-center justify-center"
            :class="{ 'active-value-type': selectedType === type }"
            x-small
            @click="onChangeValuesType(index)"
          >
            {{ type.toUpperCase() }}
          </v-chip>
        </div>
      </template>
      <template v-else>
        <v-chip-group
          v-model="selectedType"
          class="interval-chips"
          mandatory
          column
        >
          <v-chip
            v-for="type in valuesTypes"
            :key="type"
            class="direction-ltr"
            active-class="active-value-type"
            x-small
            @click="onChangeValuesType(valuesTypes.indexOf(type))"
          >
            {{ type.toUpperCase() }}
          </v-chip>
        </v-chip-group>
      </template>
    </div>

    <div class="flex-row-between-center mt-1">
      <div class="text-subtitle-2 tableText--text">Import Excel:</div>
      <v-file-input
        class="excel-input"
        type="file"
        @change="handleFileUpload"
        accept=".xlsx, .xls"
        dense
        solo
        flat
        prepend-icon=""
        prepend-inner-icon="mdi-import"
        :clearable="false"
      />
    </div>
  </v-card>
</template>

<script>
import { SET_ALERT } from "@/core/services/store/modules/alert/alert.module";
import {
  GET_PREDICTIONS_HISTORY,
  SET_HMI_PARAMS,
} from "@/core/services/store/modules/hmi/hmi.module";
import * as XLSX from "xlsx";

export default {
  name: "HMISetting",

  props: {
    recommendation: { type: Boolean },
  },

  data() {
    return {
      valuesTypes: this.recommendation
        ? ["default", "latest", "empty", "predicted"]
        : ["default", "latest", "empty"],
      selectedType: "default",
      csvData: {},
    };
  },

  methods: {
    async onChangeValuesType(typeIndex) {
      const selectedType = this.valuesTypes[typeIndex];
      this.selectedType = selectedType;
      if (selectedType === "predicted") {
        try {
          const response = await this.$store.dispatch(GET_PREDICTIONS_HISTORY, {
            limit: 1,
          });
          const lastPrediction = response?.data?.data?.[0];
          if (lastPrediction?.input_parameters?.length) {
            const mapData = {};
            lastPrediction.input_parameters.forEach((p) => {
              const key = p.parameter.name;
              const value =
                typeof p.value === "object" ? p.value.parsedValue : p.value;
              mapData[key] = value;
            });
            this.$store.commit(SET_HMI_PARAMS, {
              type: "empty",
              data: mapData,
              checkEnable: this.recommendation,
            });
          }
        } catch (error) {
          this.$store.commit(SET_ALERT, {
            text: this.$t("failedToLoadLastPrediction"),
            isError: true,
          });
        }
        return;
      }
      this.$store.commit(SET_HMI_PARAMS, {
        type: selectedType,
        checkEnable: this.recommendation,
      });
    },
    handleFileUpload(file) {
      if (file && (file.name.endsWith(".xlsx") || file.name.endsWith(".xls"))) {
        this.parseExcel(file);
      } else {
        this.$store.commit(SET_ALERT, {
          text: this.$t("excelUploadError"),
          isError: true,
        });
      }
    },
    parseExcel(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);
        const mapData = {};
        jsonData.forEach((row) => {
          if (row.parameter && row.value !== undefined) {
            mapData[row.parameter] = Number(row.value);
          }
        });
        this.$store.commit(SET_HMI_PARAMS, {
          type: "empty",
          data: mapData,
          checkEnable: this.recommendation,
        });
      };
      reader.readAsArrayBuffer(file);
    },
  },
};
</script>

<style lang="scss">
.hmi-setting {
  direction: ltr;
  position: absolute;
  left: 10px;
  top: 10px;
  padding: 5px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-height: fit-content;

  & .v-slide-group__content {
    padding: 0 !important;
    gap: 5px;
  }
  & .v-chip {
    margin-inline: 0 !important;
  }
  & .active-value-type {
    color: white !important;
    background-color: var(--v-mainBlue-base) !important;
  }

  .excel-input {
    border: 1px solid var(--v-lightGrey-base);
    direction: ltr !important;
    max-width: 85px;
    & .v-input__control {
      min-height: 16px !important;
      max-height: 16px !important;
    }
    & .v-text-field__details {
      display: none;
    }
    & .v-input__slot {
      background-color: var(--v-background-base) !important;
      padding: 0 !important;
      margin: 0 !important;
      min-height: 16px !important;
      max-height: 16px !important;
      border-radius: 2px !important;
    }
    & .v-text-field__suffix {
      font-size: 8px !important;
      color: var(--v-infoGreen-base);
    }
    & .v-file-input__text {
      font-size: 12px !important;
    }
    & input {
      height: 16px;
      max-height: 16px !important;
      font-size: 9px;
      direction: ltr;
    }
    & button {
      font-size: 14px !important;
    }
    & i {
      font-size: 14px;
      margin-left: -10px;
    }
  }
}
</style>
